<template>
  <div>
    <CustomError v-if="is_error" />
    <Loading v-if="is_loading" />
    <v-data-table
      :headers="[
        { text: 'Date', sortable: false },
        ...headers,
        { text: 'Status', sortable: false }
      ]"
      :items="orders"
      v-if="!is_loading"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:body="{ items }">
        <tbody>
          <tr
            v-for="order in items"
            :key="order._id"
            :style="`background:${getStatusColor(order)}`"
          >
            <td @click="orderClick(order._id)">
              {{ order_date(order) }}
            </td>
            <td v-for="(header, i) in headers" :key="i" @click="orderClick(order._id)">
              {{ getOrderFieldData(order, header).text }}
            </td>

            <td>
              <v-select
                :items="getStatusesTitles()"
                v-model="order.data.status"
                @change="changed(order)"
              ></v-select>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import settings from './settings'
import Loading from '@/components/Loading'
import CustomError from '@/components/CustomError'
import { mapActions, mapGetters } from 'vuex'
import ORDER_STATUSES from '@/constants/orderStatuses'

export default {
  name: 'Orders',
  data() {
    return {
      ORDER_STATUSES
    }
  },
  mounted() {
    this.load()
  },
  computed: {
    orders() {
      return this.allOrders()
    },
    headers() {
      return this.getHeaders()
    },
    is_loading() {
      return this.isLoading()
    },
    is_error() {
      return this.isError()
    }
  },
  components: {
    Loading,
    CustomError
  },
  methods: {
    ...mapGetters('orders', ['allOrders', 'isLoading', 'isError']),
    ...mapActions('orders', ['load', 'add', 'update', 'delete']),
    ...mapGetters('user', ['user']),
    order_date(order) {
      return new Date(order.createdAt).toLocaleDateString(
        ...Object.values(settings.dateDisplaySettings)
      )
    },
    changed(item) {
      this.update(item)
    },
    getOrderFieldData(order, header) {
      if (header.parent && order.data[header.parent]) return order.data[header.parent][header.name]
      else if (order.data[header.name]) return order.data[header.name]
      else return ''
    },
    getStatusesTitles() {
      return Object.keys(ORDER_STATUSES)
        .filter(key => ORDER_STATUSES[key].text)
        .map(key => ({
          text: ORDER_STATUSES[key].text,
          value: key
        }))
    },
    orderClick(orderId) {
      this.$router.push({
        path: `/orders/${orderId}`
      })
    },
    setValue(item, title, prop) {
      item.value = prop ? item.data[title][prop] : item.data[title]
    },
    getStatusColor(order) {
      if (order.data.status && ORDER_STATUSES[order.data.status])
        return ORDER_STATUSES[order.data.status].color
      return 'white'
    },
    getHeaders() {
      const headers = []
      if (this.orders.length > 0) {
        const firstOrder = this.orders[0]
        if (settings.fieldsToDisplay) {
          settings.fieldsToDisplay.forEach(item => {
            if (
              item.fieldName in firstOrder.data ||
              item.fieldName in firstOrder.data.fields ||
              item.fieldName in firstOrder.data.fieldsFixed
            ) {
              headers.push({
                text: item.fieldTitle,
                value: `createdAt`,
                sortable: false,
                name: item.fieldName,
                parent: item.fieldPropParent
              })
            }
          })
        }
        if (headers.length == 0) {
          const fieldTitles = Object.keys(firstOrder.data.fields)
          const displayFieldNumber = Math.min(3, fieldTitles.length)
          for (let i = 0; i < displayFieldNumber; i++) {
            headers.push({
              text: fieldTitles[i],
              value: `createdAt`,
              sortable: false,
              name: fieldTitles[i],
              parent: 'fields'
            })
          }
        }
      }
      return headers
    }
  }
}
</script>

<style lang="scss" scoped>
tr {
  cursor: pointer;
}
</style>
